import type { IWorkspaceMember } from '@platform/core/types';

/**
 * Кількість відкритих записів, призначених учасникові (поле `openItems` переліку учасників API; прототип v4 lkAdv «Відкриті елементи»);
 * без поля — undefined. Чиста функція.
 */
export function openItemsOf(member: IWorkspaceMember): number | undefined {
  return 'openItems' in member && typeof member.openItems === 'number' ? member.openItems : undefined;
}
